<template>
  <!-- Modal de Registro -->
  <div
    class="modal fade"
    id="loginRegisterModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="loginRegisterModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-t="'register.title'"></h5>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Cerrar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="header-pic">
          <img src="/img/head_register.jpg" />
        </div>
        <div class="modal-body">
          <form
            class="form-signin form-regist"
            v-on:submit.prevent="sendForm()"
            data-vv-scope="form_registro"
          >
            <input
              type="text"
              id="inputNameRegister"
              name="nombre"
              class="form-control"
              :placeholder="$t('register.inputs.name')"
              v-validate="'required|twoWord'"
              autofocus
              v-model="form_data.name"
            />
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_registro.nombre')"
              >{{ errors_validate.first("form_registro.nombre") }}</span
            >

            <input
              type="text"
              id="inputCompanyRegister"
              name="empresa"
              class="form-control"
              :placeholder="$t('register.inputs.company')"
              v-validate="'required'"
              v-model="form_data.company"
            />
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_registro.empresa')"
              >{{ errors_validate.first("form_registro.empresa") }}</span
            >

            <input
              type="text"
              id="inputTelRegister"
              name="telefono"
              class="form-control"
              :placeholder="$t('register.inputs.phone')"
              @keypress="isNumber($event)"
              v-validate="'required'"
              v-model="form_data.phone"
            />
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_registro.telefono')"
              >{{ errors_validate.first("form_registro.telefono") }}</span
            >

            <input
              type="text"
              id="inputUserRegister"
              name="usuario"
              class="form-control"
              :placeholder="$t('register.inputs.email')"
              @keypress="withoutSpace($event)"
              @input="form_data.email = $event.target.value.toLowerCase()"
              v-validate="'required|email'"
              v-model.trim="form_data.email"
            />
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_registro.usuario')"
              >{{ errors_validate.first("form_registro.usuario") }}</span
            >

            <select
              name="country"
              id="country"
              class="form-control"
              v-model="form_data.country_code"
            >
              <option value="" disabled>
                {{ $t("register.inputs.country") }}
              </option>
              <option
                v-for="country in countries"
                v-bind:key="country.code"
                v-bind:value="country.code"
              >
                {{ country.name }}
              </option>
            </select>
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_registro.country')"
              >{{ errors_validate.first("form_registro.country") }}</span
            >

            <input
              type="password"
              id="inputPasswordRegister"
              name="clave"
              class="form-control"
              :placeholder="$t('register.inputs.pass')"
              @keypress="withoutSpace($event)"
              v-validate="{ required: true }"
              v-model.trim="form_data.password"
            />
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_registro.clave')"
              >{{ errors_validate.first("form_registro.clave") }}</span
            >
            <input
              type="password"
              id="inputPasswordRepRegister"
              name="clave_repetir"
              class="form-control"
              :placeholder="$t('register.inputs.confirm_pass')"
              @keypress="withoutSpace($event)"
              v-validate="'required'"
            />
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_registro.clave_repetir')"
              >{{ errors_validate.first("form_registro.clave_repetir") }}</span
            >
            <div class="col-md-12 cont-captcha">
              <!-- <vue-recaptcha
                ref="invisibleRecaptcha2"
                :sitekey="sit_ky"
                :loadRecaptchaScript="true"
                :elementId="'invisibleRecaptcha2'"
                size="invisible"
                @verify="onCaptchaVerified"
                @expired="onExpired"
              ></vue-recaptcha> -->
            </div>

            <div class="cont_loader">
              <vue-loading
                type="spin"
                color="#d9544e"
                :size="{ width: '30px', height: '30px' }"
                v-show="validando_captcha"
              ></vue-loading>
            </div>

            <div class="bt-signin-box">
              <button
                class="material-btn bt_red"
                :disabled="is_send"
                type="submit"
              >
                {{ $t("register.actions.register") }}
              </button>
            </div>

            <!--   <span class="error text-danger" v-show="msg_error_text != ''">{{ msg_error_text }}</span>   -->
            <span
              v-for="(item, err_key) in list_errors_c"
              :key="err_key"
              class="error text-danger"
              >{{ item }}</span
            >
          </form>

          <div class="legal-box">
            {{ $t("register.security_info.text_1") }}
            <a href="/terminos_condiciones" target="_blank">
              {{ $t("register.security_info.text_2") }}
            </a>
            {{ $t("register.security_info.and") }}
            <a href="/politicas_privacidad" target="_blank">
              {{ $t("register.security_info.text_3") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Snackbar from "node-snackbar";
import { setTimeout } from "timers";
import _ from "lodash";

import * as CountryRequest from "../../request/countries.js";
import * as AuthRequest from "../../request/auth.js";
import AuthMixins from "../../mixins/auth.js";
import { Validator } from "vee-validate";

Validator.extend("twoWord", {
  getMessage: (field) => "The " + field + " value is not valid.",
  validate: (value) => value.trim().includes(" "),
});

export default {
  props: {
    validateRecaptcha: {
      type: Function,
      default: (item) => {},
    },
    resetTheRecaptcha: {
      type: Function,
      default: () => {},
    },
  },
  mixins: [AuthMixins],
  mounted() {
    let vm = this;
    $(document).ready(function () {
      $("#loginRegisterModal").on("show.bs.modal", function (e) {
        setTimeout(() => {
          document.getElementById("app").style.position = "relative";
        }, 500);
      });

      $("#loginRegisterModal").on("hidden.bs.modal", function () {
        document.getElementById("app").style.position = null;
      });
    });

    AuthRequest.getIP().then((response) => {
      vm.user_ip = response.data;
    });

    CountryRequest.getList().then((response) => {
      if (response.data && response.data.length > 0) {
        vm.countries = response.data;
      }
      // vm.countries = response.data[this.$i18n.locale].country;
    });
  },
  data() {
    return {
      form_data: {
        name: "",
        company: "",
        phone: "",
        country_code: "",
        email: "",
        password: "",
      },
      countries: [],
      is_send: false,
      msg_error_text: "",
      url_api: window.url_api,
      sit_ky: process.env.VUE_APP_RECAPTH_KEY_PROD,
      list_errors: {},
      user_ip: "",
      ipInfo: {},
      currency_type: "RD",
    };
  },
  computed: {
    list_errors_c: function () {
      let result = [];
      _.forIn(this.list_errors, (element, key) => {
        _.forEach(element, (subElement) => {
          result.push(subElement);
        });
      });
      return result;
    },
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    withoutSpace: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 32) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    sendForm() {
      this.$validator.validateAll("form_registro").then((result) => {
        if (result) {
          this.validando_captcha = true;
          this.is_send = true;
          this.validateRecaptcha("register");
        } else {
          // Si el formulario no es valido
          this.is_send = false;
        }
      });
    },
    onCaptchaVerified(token) {
      this.validando_captcha = false;
      let vm = this;
      let data = new FormData();
      for (const key in this.form_data) {
        if (this.form_data.hasOwnProperty(key)) {
          data.append(key, this.form_data[key]);
        }
      }

      let country = vm.countries.find(
        (country) => country.code === vm.form_data.country_code
      );

      data.append("ip_address", vm.user_ip);
      data.append("currency_type", country ? country.currency : "RD");
      data.append("g-recaptcha-response", token);

      AuthRequest.postRegister(data)
        .then((response) => {
          this.is_send = false;
          if (response.data.success) {
            vm.msg_error_text = null;
            $("#loginRegisterModal").modal("hide");
            $("body").removeClass("modal-open");
            $(".modal-backdrop").remove();

            for (const key in vm.form_data) {
              if (vm.form_data.hasOwnProperty(key)) {
                vm.form_data[key] = null;
              }
            }

            setTimeout(() => {
              vm.$validator.reset();
            }, 300);

            setTimeout(() => {
              $("#confirmRegisterModal").modal("show");
            }, 800);
          } else {
            vm.list_errors = response.data.errors;
            vm.msg_error_text = null;
          }
        })
        .catch((err_) => {
          vm.is_send = false;
          Snackbar.show({
            text: this.$t("register.error_admin"),
            pos: "bottom-center",
            backgroundColor: "#ff1744",
            actionText: "<b>" + this.$t("boton.cerrar") + "</b>",
            actionTextColor: "#fff",
          });
        });
    },
  },
};
</script>

<i18n src="@/locale/modals/generic.json" />
<i18n src="@/locale/modals/register.json" />
